@if (showMarketHelp) {
    <ms-market-help [optionGroup]="optionGroup" [eventHelpText]="eventHelpText" />
}
@if (isTeamGroupingEnabled()) {
    <ms-team-grouping-tab-bar [event]="event" [optionGroup]="optionGroup" (teamGroupingChange)="onTeamGroupingChange($event)" />
}
<div class="option-group-container goal-scorer-container" [style.--option-group-rows]="visibleOptions().length" [ngClass]="scoreOptionsClass()">
    @if (showHeaders()) {
        <div class="option-group-header">
            <span></span>
            @for (header of headers(); track header.name) {
                <span class="option-header-name"> {{ header.name }} </span>
            }
        </div>
    }
    <ng-container *rxFor="let group of optionsToDisplay$; strategy: renderStrategy$; trackBy: trackGroup; renderCallback: groupsRendered$">
        <div [ngClass]="isShowOptionImage ? 'attribute-key participant-jersey' : 'attribute-key'">
            @if (isShowHeadshotImage || isShowOptionImage) {
                <ms-participant-image
                    class="participant-logo"
                    [participantImage]="getParticipantImage(group?.options)"
                    [showLogoColor]="true"
                    [participantType]="isShowHeadshotImage ? participantType.Player : participantType.Team"
                    [sportId]="event?.sport.id" />
            }
            <span class="goal-scorer-player-name">{{ group.attribute }}</span>
        </div>
        @for (option of group.options; track trackOption($index, option)) {
            @if (option) {
                <ms-option
                    [ngClass]="{ 'player-image': isShowOptionImage }"
                    [tracking]="{
                        source: tracking,
                        calendarTitle: calendarTrack,
                        moduleType: trackingModuleType,
                        controllerTabName: controllerTabName,
                        playersName: option.name,
                    }"
                    [option]="option"
                    [optionGroup]="optionGroup"
                    [event]="event"
                    [sourceOfPick]="sourceOfPick"
                    [betDetails]="betDetails" />
            } @else {
                <div class="option">
                    <div class="offline option-pick"><div class="value">-</div></div>
                </div>
            }
        }
    </ng-container>
</div>
@if (!isInSheetView) {
    <ms-option-panel-bottom-action [data]="showMoreData()" (showMore)="onShowMore($event)" (showAllRequested)="showAllRequested.next()" />
}
